import React from 'react'
import { useTranslation } from 'react-i18next'

import { TContact } from '../../../common/validations/contractContacts'
import { ContactCategory } from '../../../common/types'

import { ContactCard } from 'components/ContactCard/ContactCard'

type Props = {
  contacts: TContact[]
}

export const MaintenanceContacts: React.FC<Props> = ({ contacts }) => {
  const { t } = useTranslation(['contact'])
  const propertyMaintenance = contacts.find(
    (c) => c.contactCategory === ContactCategory.PROPERTY_MAINTENANCE
  )

  if (!propertyMaintenance?.phoneNumber) {
    return null
  }

  return (
    <ContactCard
      title={propertyMaintenance.officeName}
      contact={propertyMaintenance}
      showName
      role={t('contact:propertyMaintenance')}
    />
  )
}
